/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OperatorRouteImport } from './routes/_operator'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OperatorIndexRouteImport } from './routes/_operator/index'
import { Route as OperatorBidsRouteImport } from './routes/_operator/bids'
import { Route as OperatorDealersRouteImport } from './routes/_operator/dealers'
import { Route as OperatorDepositsRouteImport } from './routes/_operator/deposits'
import { Route as OperatorInlandRouteImport } from './routes/_operator/inland'
import { Route as OperatorInvoicesRouteImport } from './routes/_operator/invoices'
import { Route as OperatorOperatorsRouteImport } from './routes/_operator/operators'
import { Route as OperatorRatesRouteImport } from './routes/_operator/rates'
import { Route as OperatorVehiclesRouteImport } from './routes/_operator/vehicles'
import { Route as OperatorDealersDealerIdRouteImport } from './routes/_operator/dealers_.$dealerId'

const OperatorRoute = OperatorRouteImport.update({
  id: '/_operator',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OperatorIndexRoute = OperatorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperatorRoute,
} as any)
const OperatorBidsRoute = OperatorBidsRouteImport.update({
  id: '/bids',
  path: '/bids',
  getParentRoute: () => OperatorRoute,
} as any)
const OperatorDealersRoute = OperatorDealersRouteImport.update({
  id: '/dealers',
  path: '/dealers',
  getParentRoute: () => OperatorRoute,
} as any)
const OperatorDepositsRoute = OperatorDepositsRouteImport.update({
  id: '/deposits',
  path: '/deposits',
  getParentRoute: () => OperatorRoute,
} as any)
const OperatorInlandRoute = OperatorInlandRouteImport.update({
  id: '/inland',
  path: '/inland',
  getParentRoute: () => OperatorRoute,
} as any)
const OperatorInvoicesRoute = OperatorInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => OperatorRoute,
} as any)
const OperatorOperatorsRoute = OperatorOperatorsRouteImport.update({
  id: '/operators',
  path: '/operators',
  getParentRoute: () => OperatorRoute,
} as any)
const OperatorRatesRoute = OperatorRatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => OperatorRoute,
} as any)
const OperatorVehiclesRoute = OperatorVehiclesRouteImport.update({
  id: '/vehicles',
  path: '/vehicles',
  getParentRoute: () => OperatorRoute,
} as any)
const OperatorDealersDealerIdRoute = OperatorDealersDealerIdRouteImport.update({
  id: '/dealers_/$dealerId',
  path: '/dealers/$dealerId',
  getParentRoute: () => OperatorRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof OperatorIndexRoute
  '/login': typeof LoginRoute
  '/bids': typeof OperatorBidsRoute
  '/dealers': typeof OperatorDealersRoute
  '/deposits': typeof OperatorDepositsRoute
  '/inland': typeof OperatorInlandRoute
  '/invoices': typeof OperatorInvoicesRoute
  '/operators': typeof OperatorOperatorsRoute
  '/rates': typeof OperatorRatesRoute
  '/vehicles': typeof OperatorVehiclesRoute
  '/dealers/$dealerId': typeof OperatorDealersDealerIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/bids': typeof OperatorBidsRoute
  '/dealers': typeof OperatorDealersRoute
  '/deposits': typeof OperatorDepositsRoute
  '/inland': typeof OperatorInlandRoute
  '/invoices': typeof OperatorInvoicesRoute
  '/operators': typeof OperatorOperatorsRoute
  '/rates': typeof OperatorRatesRoute
  '/vehicles': typeof OperatorVehiclesRoute
  '/': typeof OperatorIndexRoute
  '/dealers/$dealerId': typeof OperatorDealersDealerIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_operator': typeof OperatorRouteWithChildren
  '/login': typeof LoginRoute
  '/_operator/bids': typeof OperatorBidsRoute
  '/_operator/dealers': typeof OperatorDealersRoute
  '/_operator/deposits': typeof OperatorDepositsRoute
  '/_operator/inland': typeof OperatorInlandRoute
  '/_operator/invoices': typeof OperatorInvoicesRoute
  '/_operator/operators': typeof OperatorOperatorsRoute
  '/_operator/rates': typeof OperatorRatesRoute
  '/_operator/vehicles': typeof OperatorVehiclesRoute
  '/_operator/': typeof OperatorIndexRoute
  '/_operator/dealers_/$dealerId': typeof OperatorDealersDealerIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/bids'
    | '/dealers'
    | '/deposits'
    | '/inland'
    | '/invoices'
    | '/operators'
    | '/rates'
    | '/vehicles'
    | '/dealers/$dealerId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/bids'
    | '/dealers'
    | '/deposits'
    | '/inland'
    | '/invoices'
    | '/operators'
    | '/rates'
    | '/vehicles'
    | '/'
    | '/dealers/$dealerId'
  id:
    | '__root__'
    | '/_operator'
    | '/login'
    | '/_operator/bids'
    | '/_operator/dealers'
    | '/_operator/deposits'
    | '/_operator/inland'
    | '/_operator/invoices'
    | '/_operator/operators'
    | '/_operator/rates'
    | '/_operator/vehicles'
    | '/_operator/'
    | '/_operator/dealers_/$dealerId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  OperatorRoute: typeof OperatorRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_operator': {
      id: '/_operator'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OperatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_operator/': {
      id: '/_operator/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof OperatorIndexRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/bids': {
      id: '/_operator/bids'
      path: '/bids'
      fullPath: '/bids'
      preLoaderRoute: typeof OperatorBidsRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/dealers': {
      id: '/_operator/dealers'
      path: '/dealers'
      fullPath: '/dealers'
      preLoaderRoute: typeof OperatorDealersRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/deposits': {
      id: '/_operator/deposits'
      path: '/deposits'
      fullPath: '/deposits'
      preLoaderRoute: typeof OperatorDepositsRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/inland': {
      id: '/_operator/inland'
      path: '/inland'
      fullPath: '/inland'
      preLoaderRoute: typeof OperatorInlandRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/invoices': {
      id: '/_operator/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof OperatorInvoicesRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/operators': {
      id: '/_operator/operators'
      path: '/operators'
      fullPath: '/operators'
      preLoaderRoute: typeof OperatorOperatorsRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/rates': {
      id: '/_operator/rates'
      path: '/rates'
      fullPath: '/rates'
      preLoaderRoute: typeof OperatorRatesRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/vehicles': {
      id: '/_operator/vehicles'
      path: '/vehicles'
      fullPath: '/vehicles'
      preLoaderRoute: typeof OperatorVehiclesRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/dealers_/$dealerId': {
      id: '/_operator/dealers_/$dealerId'
      path: '/dealers/$dealerId'
      fullPath: '/dealers/$dealerId'
      preLoaderRoute: typeof OperatorDealersDealerIdRouteImport
      parentRoute: typeof OperatorRoute
    }
  }
}

interface OperatorRouteChildren {
  OperatorBidsRoute: typeof OperatorBidsRoute
  OperatorDealersRoute: typeof OperatorDealersRoute
  OperatorDepositsRoute: typeof OperatorDepositsRoute
  OperatorInlandRoute: typeof OperatorInlandRoute
  OperatorInvoicesRoute: typeof OperatorInvoicesRoute
  OperatorOperatorsRoute: typeof OperatorOperatorsRoute
  OperatorRatesRoute: typeof OperatorRatesRoute
  OperatorVehiclesRoute: typeof OperatorVehiclesRoute
  OperatorIndexRoute: typeof OperatorIndexRoute
  OperatorDealersDealerIdRoute: typeof OperatorDealersDealerIdRoute
}

const OperatorRouteChildren: OperatorRouteChildren = {
  OperatorBidsRoute: OperatorBidsRoute,
  OperatorDealersRoute: OperatorDealersRoute,
  OperatorDepositsRoute: OperatorDepositsRoute,
  OperatorInlandRoute: OperatorInlandRoute,
  OperatorInvoicesRoute: OperatorInvoicesRoute,
  OperatorOperatorsRoute: OperatorOperatorsRoute,
  OperatorRatesRoute: OperatorRatesRoute,
  OperatorVehiclesRoute: OperatorVehiclesRoute,
  OperatorIndexRoute: OperatorIndexRoute,
  OperatorDealersDealerIdRoute: OperatorDealersDealerIdRoute,
}

const OperatorRouteWithChildren = OperatorRoute._addFileChildren(
  OperatorRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  OperatorRoute: OperatorRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
